(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mortalis-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initModalHandlers() {
    const modal = document.querySelector("#mortalisQuizModal");
    const openBtn = document.querySelector("#mortalisQuizBtn");
    const closeBtn = document.querySelector("#mortalisQuizClose");

    if (openBtn && modal) {
      openBtn.addEventListener("click", function () {
        modal.style.display = "block";
        document.body.style.overflow = "hidden";
      });
    }

    if (closeBtn && modal) {
      closeBtn.addEventListener("click", function () {
        modal.style.display = "none";
        document.body.style.overflow = "auto";
      });
    }

    window.addEventListener("click", function (event) {
      if (event.target === modal) {
        modal.style.display = "none";
        document.body.style.overflow = "auto";
      }
    });
  }

  if (document.readyState !== "loading") {
    initModalHandlers();
  } else {
    document.addEventListener("DOMContentLoaded", initModalHandlers);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
